import React, { useEffect } from 'react';
import './Milestone.css';

const Milestone = () => {
    const milestones = [
            {
                title: "Brainstorming workshop",
                date: "10-Nov-2022"
            },
            {
                title: "Group registration",
                date: "16-Dec-2022"
            },
            {
                title: "Topic evaluation",
                date: "20-Jan-2023"
            },
            {
                title: "Project charter",
                date: "30-Jan-2023"
            },
            {
                title: "Proposal reports (draft)",
                date: "24-Mar-2023"
            },
            {
                title: "Proposal presentation",
                date: "27-31 Mar-2023"
            },
            {
                title: "Proposal reports (final - for marking)",
                date: "5-May-2023"
            },
            {
                title: "Progress Presentation – I",
                date: "22-26 May-2023"
            },
            {
                title: "Status document I",
                date: "22-May-2023"
            },
            {
                title: "Research paper",
                date: "20-Jun-2023"
            },
            {
                title: "Final reports",
                date: "10-Sep-2023"
            },
            {
                title: "Progress Presentation – II",
                date: "4-6 Sep-2023"
            },
            {
                title: "Status document II",
                date: "4-6 Sep-2023"
            },
            {
                title: "Research paper registration notification",
                date: "6-Nov-2023"
            },
            {
                title: "Final presentation & VIVA",
                date: "30-Oct to 03-Nov"
            },
            {
                title: "Project website",
                date: "6-Nov-2023"
            },
            {
                title: "Research logbook",
                date: "30-Oct-2023"
            },
            {
                title: "Final Report (proofread)",
                date: "27-Nov-2023"
            }
    ];

    useEffect(() => {
        const milestoneCards = document.querySelectorAll('.milestone-card');

        const handleScroll = () => {
            milestoneCards.forEach((card, index) => {
                const cardPosition = card.getBoundingClientRect().top;
                const screenPosition = window.innerHeight / 1.3;

                if (cardPosition < screenPosition) {
                    card.classList.add('active');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="milestone-container" id="milestones">
            <div className="milestone-content">
                <h1>Milestones</h1>
                <div className="milestone-card-container">
                    {milestones.map((milestone, index) => (
                        <div key={index} className="milestone-card">
                            <div className="milestone-side milestone-side-1">
  <div className="milestone-marker"></div>
  {index !== milestones.length - 1 && <div className="arrow-down"></div>}
</div>
                            <div className="milestone-side milestone-side-2">
                                <h4 className="milestone-title">{milestone.title}</h4>
                            </div>
                            <div className="milestone-side milestone-side-3">
                                <h4 className="milestone-date">{milestone.date}</h4>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Milestone;